import script from "./LinkDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./LinkDialog.vue?vue&type=script&lang=ts&setup=true"

import "./LinkDialog.vue?vue&type=style&index=0&id=469f9b66&lang=scss&scoped=true"

import exportComponent from "C:\\work\\to-create\\bailing\\yc-bailing-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-469f9b66"]])

export default __exports__